import { HttpErrorResponse } from '@angular/common/http';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { filter, map } from 'rxjs/operators';
import { ApiAccessService } from '../api-access.service';
import { shareService } from '../language.service';

enum InputError {
  INVALID_NUMBER = 'מספר לא תקין',
  INVALID_INPUT = 'יש להזין 9 ספרות',
  NOT_FOUND = 'לא נמצאו תוצאות'
}

@Component({
  selector: 'app-insert-idnum',
  templateUrl: './insert-idnum.component.html',
  styleUrls: ['./insert-idnum.component.scss']
})
export class InsertIdnumComponent implements OnInit {
  InputError = InputError;
  isMobile: boolean;
  error: InputError;
  goToStation: string;
  redBorder: boolean;
  disableInput: boolean;
  digitInputValues: string[] = ['','','','','','','','',''];
  private keydownNextValue: string[] = [null,null,null,null,null,null,null,null,null];
  @ViewChild('firstInput') firstInput: ElementRef<HTMLInputElement>;
  private inputFocus: boolean;

  nextBtnText: string;
  selectCompanyText: string;
  companyText: string;
  enterIdnumText: string;

  companies: {id: string, name: string}[];

  constructor(private api: ApiAccessService, private share: shareService, private router: Router, private route: ActivatedRoute) {
    this.isMobile = isMobileOrTablet();
  }

  ngOnInit(): void {
    if (this.share.language$.value.id === 'ar'){
      this.nextBtnText = 'التالي';
      this.selectCompanyText = 'اختر شركه النقل';
      this.companyText = 'شركه النقل';
      this.enterIdnumText = 'رقم الهويه';
      this.goToStation = 'الرجاء التوجه لموظف الميزان';
    } else {
      this.nextBtnText = 'המשך';
      this.selectCompanyText = 'בחר חברת הובלה';
      this.companyText = 'חברת הובלה';
      this.enterIdnumText = 'תעודת זהות';
      this.goToStation = 'גש לעמדת השוקל';
    }
  }

  digitKeydown(which:0|1|2|3|4|5|6|7|8, event: KeyboardEvent){
    if (this.keydownNextValue[which] && which < 8) which++;// when keydownValue is not null, its means a keyboard had push rapidly before focus pass to next input; therefor, it's consider as if it do pass to the next
    let key = +event.key;
    if (/\s/.test(event.key) || isNaN(key)){
      let element = (event.target as HTMLInputElement);
      if (event.key === 'Backspace' || event.key === 'Delete') {
        // let i: number = which;
        // if (event.code === 'Backspace' && element.selectionStart === element.selectionEnd && element.selectionStart === 0){
        //   if (which === 0) return;
        //   i--;
        // }
        // if (event.code === 'Delete' && element.selectionStart === element.selectionEnd && element.selectionStart === 1){
        //   if (which === 8) return;
        //   i++;
        // }
        // for (; i < 8; i++){
        //   this.keydownNextValue[i] = this.digitInputValues[i+1] ? this.digitInputValues[i+1] : '';
        // }
      } else {
        this.keydownNextValue[which] = null;
      }
    } else {
      this.keydownNextValue[which] = event.key;
    }
  }

  digitKeyup(which:0|1|2|3|4|5|6|7|8, event: KeyboardEvent){
    // console.log('up('+which+'): '+event.key);
    let el = (event.target as HTMLInputElement);
    let moveOn = (which:0|1|2|3|4|5|6|7|8, el:HTMLInputElement) => {
      if (which === 8){
        el.blur();
      } else {
        let el2: HTMLInputElement = document.getElementById('digit-'+(which+1)) as HTMLInputElement;
        // window.setTimeout(() => {
        el2.focus();
          // el2.setSelectionRange(0,0);
        // });
      }
    }
    let moveBack = (which:0|1|2|3|4|5|6|7|8|number, el:HTMLInputElement) => {
      if (which === 0){
        el.blur();
      } else {
        let el2: HTMLInputElement = document.getElementById('digit-'+(which-1)) as HTMLInputElement;
        el2.focus();
        // el2.setSelectionRange(1,1);
      }
    }
    if (event.key === 'Backspace' || event.key === 'Delete') {
      let curr = 0;
      for (let i = 0; i <= 8; i++){
        if (i !== which && !!this.digitInputValues[i] && !isNaN(+this.digitInputValues[i])){
          this.digitInputValues[curr++] = this.digitInputValues[i];
        }
      }
      for (let i = curr; i <= 8; i++){
        this.digitInputValues[i] = '';
      }
      let el3: HTMLInputElement = document.getElementById('digit-'+Math.max(curr-1, 0)) as HTMLInputElement;
      el3.focus();
      // let start = this.keydownNextValue.findIndex(s => s !== null);
      // for (let k = start; k <= 8; k++){
      //   this.digitInputValues[k] = this.keydownNextValue[k];
      //   this.keydownNextValue[k] = null;
      // }
      // if (event.code === 'Backspace' && start !== which){
      //   moveBack(which,el);
      // } else {
      //   // window.setTimeout(() => el.setSelectionRange(0,0));
      // }
      // if (event.code === 'Delete' && start !== which){
      //   moveOn(which,el);
      // } else {
      //   // window.setTimeout(() => el.setSelectionRange(1,1));
      // }
    } else
    if (this.keydownNextValue[which]){
      let key = +this.keydownNextValue[which];
      el.value = this.digitInputValues[which] = this.keydownNextValue[which];
      this.keydownNextValue[which] = null;
      moveOn(which,el);
    } else if (event.code === 'ArrowRight') {
      if (which !== 8){
        moveOn(which, null);
      }
    } else if (event.code === 'ArrowLeft') {
      if (which !== 0){
        moveBack(which,null);
      }
    } else {
      el.value = this.digitInputValues[which];
      // el.setSelectionRange(0,1);
    }
  }

  idenValue(){
    return this.digitInputValues.reduce((prev, curr) => curr?.length > 0 ? `${prev}${curr}` : `${prev}_`, '');
  }

  digitBlur(event: FocusEvent){
    window.setTimeout(() => document.activeElement.tagName !== 'INPUT' ? this.inputFocus = false : () => {});
  }

  digitFocus(event: FocusEvent){
    this.error = null;
    if (!this.inputFocus){
      this.firstInput.nativeElement.focus();
      // this.firstInput.nativeElement.setSelectionRange(0,1);
    } else {
      // (event.target as HTMLInputElement).setSelectionRange(0,1);
    }
    this.inputFocus = true;
    this.error = null
  }

  checkInput(): InputError {
    // if (this.digitInputValues.reduce((p,c) => !c && p, true)){
    //   return this.errorMessage(InputError.NO_INPUT);
    // }
    let idenString = this.idenValue();
    if (isNaN(+idenString)){
      return InputError.INVALID_INPUT;
    }
    if (!isValidID(idenString)){
      return InputError.INVALID_NUMBER;
    }
    return null;
  }
  
  btnClick(){
    if (this.share.courseId$.value){
      if (this.checkInput() !== null){
        this.error = this.checkInput();
      } else {
        this.api.getEmployeeCompanies(this.share.courseId$.value, this.idenValue()).subscribe(responseBody => {
          this.share.idnum$.next(responseBody.employee.idnum);
          this.share.employeeName$.next(responseBody.employee.full_name); 
          if (responseBody.shippers.length === 1){
            this.share.company$.next(responseBody.shippers[0]);
            this.router.navigate(['routes'], {relativeTo: this.route});
          } else {
            this.companies = responseBody.shippers;
            this.disableInput = true;
          }
        }, (err: HttpErrorResponse) => {
          if (err.status === 404){
            this.error = InputError.NOT_FOUND;
          }
        });
      }
    }
  }

  companySelect(company: {id:string,name:string}){    
    this.share.company$.next(company);
    this.router.navigate(['routes'], {relativeTo: this.route});
  }

  inputClick(event){
    console.log(event.target.selectionStart);
  }

  errorMessage(error: InputError): string {
    if (this.share.language$.value.id === 'ar'){
      switch(error){
        case InputError.INVALID_NUMBER: return 'الرقم غير صحيح';
        case InputError.INVALID_INPUT: return 'يجب ادخال 9 ارقام';
        case InputError.NOT_FOUND: return 'لا يوجد نتائج';
      }
    } else {
      return error;
    }
  }
}

function isValidID(str:string){
  var mone = 0, incNum;
  for (var i=0; i < 9; i++) {
     incNum = Number(str.charAt(i));
     incNum *= (i%2)+1;
     if (incNum > 9)
        incNum -= 9;
     mone += incNum;
  }
  if (mone%10 == 0)
     return true;
  else
     return false;
}
export function isMobileOrTablet() {
  let check = false;
  (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window['opera']);
  return check;
};